import CryptoJS from 'crypto-js';

// SECURITY: this is OBFUSCATION ONLY, not real encryption. Previously the key was `${auth.jwt}` which
// stringified the config object to the literal "[object Object]" — and importing config-server here
// baked the JWT signing secret into the CLIENT bundle (token forgery). We keep the same constant key
// so encode/decode stay byte-compatible, but we no longer import any server secret. The values handled
// (e.g. the public Firebase auth domain) are not sensitive; do NOT route real secrets through this.
const OBFUSCATION_KEY = '[object Object]';

export function encode(data) {
    if (data) {
        const encryptedData = CryptoJS.AES.encrypt(data, OBFUSCATION_KEY).toString();
        return encryptedData;
    } else {
        return null;
    };
};


export function decode(data) {
    if (data) {
        let bytes = CryptoJS.AES.decrypt(data, OBFUSCATION_KEY);
        let decodedData = bytes.toString(CryptoJS.enc.Utf8);
        return decodedData;
    } else {
        return null;
    };
};

export function censorWord(str) {
    if (str) {
        if (str.length < 2) {
            return str;
        }
        var count = str.length - 2;
        return str[0] + "*".repeat(Math.max(count, 0)) + str.slice(-1);
    }
}

export function censorPhone(number) {
    return censorWord(number);
}

export function censorEmail(email) {
    if (email) {
        var arr = email.split("@");
        return censorWord(arr[0]) + "@" + censorWord(arr[1]);
    }
}
